<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog>
    <fudis-heading fudisDialogTitle [level]="1" [variant]="'lg'">{{
      t("PLAN.UNALLOCATED_COURSE_UNIT_ATTAINMENTS_DIALOG.TITLE")
    }}</fudis-heading>
    <fudis-dialog-content>
      <fudis-body-text [class]="'fudis-mb-md'">
        {{ t("PLAN.UNALLOCATED_COURSE_UNIT_ATTAINMENTS_DIALOG.DESCRIPTION") }}
        <strong>{{ data.plan.name }}</strong
        >.
      </fudis-body-text>
      @for (attainment of unallocatedCourseUnitAttainments; track attainment.id) {
        <div class="fudis-mb-sm">
          <sis-study-box
            [id]="attainment.courseUnit.id"
            [name]="attainment.courseUnit.name"
            [code]="attainment.courseUnit.code"
            [credits]="attainment.courseUnit.credits"
            [attainedCredits]="attainment.credits"
            [gradeScaleId]="attainment.gradeScaleId"
            [gradeId]="attainment.gradeId">
            <ng-container study-box="notifications">
              <sis-study-notification-box
                [useFudisLink]="true"
                [attr.aria-label]="attainment.courseUnit.name | localizedString"
                [primaryButtonText]="'SIS_COMPONENTS.STUDY.PLACE_TO_PLAN'"
                (primaryClickAction)="onAddToPlanButtonClick(attainment.courseUnit)"></sis-study-notification-box>
            </ng-container>
          </sis-study-box>
        </div>
      }
      @for (customCourseUnitAttainment of unallocatedCustomCourseUnitAttainments; track customCourseUnitAttainment.id) {
        <div class="fudis-mb-sm">
          <sis-study-box
            [id]="customCourseUnitAttainment.id"
            [type]="StudyBoxType.customAttainment"
            [name]="customCourseUnitAttainment.name"
            [gradeScaleId]="customCourseUnitAttainment.gradeScaleId"
            [gradeId]="customCourseUnitAttainment.gradeId"
            [code]="customCourseUnitAttainment.code"
            [credits]="getCustomCourseUnitCredits(customCourseUnitAttainment)"
            [attainedCredits]="customCourseUnitAttainment.credits">
            <ng-container study-box="notifications">
              <sis-study-notification-box
                [useFudisLink]="true"
                [attr.aria-label]="customCourseUnitAttainment.name | localizedString"
                [primaryButtonText]="t('SIS_COMPONENTS.STUDY.PLACE_TO_PLAN')"
                (primaryClickAction)="onAddCustomAttainmentToPlanClick(customCourseUnitAttainment)"></sis-study-notification-box>
            </ng-container>
          </sis-study-box>
        </div>
      }
    </fudis-dialog-content>
    <fudis-dialog-actions>
      <fudis-button fudisDialogClose [variant]="'secondary'" [label]="t('BUTTON.CANCEL')" />
    </fudis-dialog-actions>
  </fudis-dialog>
</ng-container>
